import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Btn, Input, Field } from "@/components/common";
import { AuthShell } from "@/pages/Login";
import { api, apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" sub="We'll email you a reset link.">
      {sent ? (
        <div data-testid="forgot-sent" className="text-sm p-4" style={{ color: "var(--si-text-2)", border: "1px solid var(--si-border)", borderRadius: 2 }}>
          If that email is registered, a reset link has been sent. The link expires in 1 hour.
        </div>
      ) : (
        <form onSubmit={submit}>
          <Field label="Email"><Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" /></Field>
          <Btn data-testid="forgot-submit" type="submit" variant="primary" className="w-full" disabled={loading}>{loading ? "Sending…" : "Send reset link"}</Btn>
        </form>
      )}
      <div className="mt-5 text-sm text-center">
        <Link to="/login" style={{ color: "var(--si-silver)" }}>Back to sign in</Link>
      </div>
    </AuthShell>
  );
}
